import { combineReducers } from 'redux';

const masterInitialState = {
  loadStatus: false,
  list: null,
};

const createInitialState = {
  loadStatus: 0,
  saveStatus: 0,

  input: {
    name: '',
    cardId: '',
    cardCompany: '',
    provinceId: '',
    provinceName: '',
    cityId: '',
    cityName: '',
    idCard: '',
    idCardImgFront: '',
    idCardImgOpposite: '',
    code: '',
  },

  bankNameList: null,
  provinces: {},
  provinceList: null,
  cities: {},
  cityList: {},
};

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_BANK_CARD_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_BANK_CARD_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        list: action.list,
      };
    }

    case 'SAVE_BANK_CARD_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        list: [action.data],
      };
    }

    default:
      return state;
  }
}

function createReducer(state = createInitialState, action) {
  switch (action.type) {
    case 'RESET_BANK_CARD_CREATE': {
      return createInitialState;
    }

    case 'UPDATE_BANK_CARD_INFO': {
      return {
        ...state,
        input: {
          ...state.input,
          ...action.info,
        },
      };
    }

    case 'LOAD_BANK_CARD_INFO': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_BANK_CARD_INFO_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        input: {
          ...state.input,
          ...action.data,
        },
      };
    }

    case 'LOAD_BANK_NAME_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        bankNameList: action.list,
      };
    }

    case 'LOAD_BANK_PROVINCE_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      let list = [];
      const dict = action.list.reduce((obj, item) => {
        const id = item.id;

        obj[id] = item.name;
        list.push(id);

        return obj;
      }, {});

      return {
        ...state,
        provinceList: list,
        provinces: dict,
      };
    }

    case 'LOAD_BANK_CITY_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      let list = [];
      const dict = action.list.reduce(
        (obj, item) => {
          const id = item.id;

          obj[id] = item.name;
          list.push(id);

          return obj;
        },
        { ...state.cities }
      );

      return {
        ...state,
        cityList: {
          ...state.cityList,
          [action.provinceId]: list,
        },
        cities: dict,
      };
    }

    case 'SAVE_BANK_CARD':
    case 'UNBIND_BANK_CARD': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'SAVE_BANK_CARD_COMPLETION':
    case 'UNBIND_BANK_CARD_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  master: masterReducer,
  create: createReducer,
});
